import { all } from '../data/all';

function Flags() {

    let countryData = [];
    
    all.forEach(thisCountry => {
        if (thisCountry.capital) { // null values...
            countryData = [...countryData, [thisCountry.name.common, thisCountry.flag]];
        }
    })

    countryData.sort();

    return(
        <code>
            { JSON.stringify(countryData) }
        </code>
    )
}

export default Flags;